import { AudioVideoOffIcon } from './AudioVideoOffIcon';

/**
 * author: Michael Irigoyen
 * id 09FB4D77-A411-4CBF-9E88-21807D804CB3
 * name audio-video-off
 * version: 4.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/audio-video-off.svg
 * tags
 * - Home Automation 
 * - Audio 
 */
export const AvReceiverOffIcon = AudioVideoOffIcon;
export default AvReceiverOffIcon